import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import '../constants/bottomNavigationBar.js';
import '../constants/footer.js';
import '../constants/footerQuickMenuItem.js';
import '../constants/global.js';
import { INPUT_FORMAT_TYPE } from '../constants/input.js';
import { getNumberString, getNumbersOnlyString } from './string.js';

var setSelectionRange = function setSelectionRange(_ref) {
  var inputElement = _ref.inputElement,
    selectionStart = _ref.selectionStart,
    selectionEnd = _ref.selectionEnd;
  inputElement.selectionStart = selectionStart;
  inputElement.selectionEnd = selectionEnd;
  inputElement.setSelectionRange(selectionStart, selectionEnd);
};
/**
 * format 전과 후의 reversedCursorPosition이 유지된다는 전제 하에 동작
 *  */
var formatValueWithCorrectCursor = function formatValueWithCorrectCursor(_ref2) {
  var _element$selectionSta;
  var element = _ref2.element,
    format = _ref2.format,
    _ref2$fixCursor = _ref2.fixCursor,
    fixCursor = _ref2$fixCursor === void 0 ? function (value) {
      return value;
    } : _ref2$fixCursor;
  var formattedValue = format(element.value);
  var reversedCursorPosition = fixCursor(element.value).length - ((_element$selectionSta = element.selectionStart) !== null && _element$selectionSta !== void 0 ? _element$selectionSta : 0);
  var correctedPos = fixCursor(formattedValue).length >= reversedCursorPosition ? fixCursor(formattedValue).length - reversedCursorPosition : 0;
  element.value = formattedValue;
  setSelectionRange({
    inputElement: element,
    selectionStart: correctedPos,
    selectionEnd: correctedPos
  });
};
var getMoveToNextStepInput = function getMoveToNextStepInput(_ref3) {
  var nextInputRef = _ref3.nextInputRef,
    maxLength = _ref3.maxLength;
  return function (e) {
    if (e.target.value.length === maxLength) {
      var _nextInputRef$current;
      (_nextInputRef$current = nextInputRef.current) === null || _nextInputRef$current === void 0 || _nextInputRef$current.focus();
    }
  };
};
var getMoveToPrevStepInput = function getMoveToPrevStepInput(_ref4) {
  var prevInputRef = _ref4.prevInputRef;
  return function (e) {
    if (prevInputRef && e.key === 'Backspace' && !e.currentTarget.value) {
      var _prevInputRef$current;
      e.preventDefault();
      (_prevInputRef$current = prevInputRef.current) === null || _prevInputRef$current === void 0 || _prevInputRef$current.focus();
    }
  };
};
var getOnChange = function getOnChange(_ref5) {
  var format = _ref5.format,
    fixCursor = _ref5.fixCursor,
    onChange = _ref5.onChange,
    onAfterChange = _ref5.onAfterChange;
  return function (e) {
    if (!onChange) {
      return undefined;
    }
    format && formatValueWithCorrectCursor({
      element: e.target,
      format: format,
      fixCursor: fixCursor
    });
    onChange(e);
    onAfterChange === null || onAfterChange === void 0 || onAfterChange(e);
  };
};
var getOnKeyDown = function getOnKeyDown(_ref6) {
  var onBeforeKeyDown = _ref6.onBeforeKeyDown,
    onKeyDown = _ref6.onKeyDown,
    onAfterKeyDown = _ref6.onAfterKeyDown;
  return function (e) {
    onBeforeKeyDown === null || onBeforeKeyDown === void 0 || onBeforeKeyDown(e);
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    onAfterKeyDown === null || onAfterKeyDown === void 0 || onAfterKeyDown(e);
  };
};
var addUnitOnValue = function addUnitOnValue(value, unit) {
  var _context;
  return value && _concatInstanceProperty(_context = "".concat(value)).call(_context, unit);
};
var removeValueOnKeyDown = function removeValueOnKeyDown(_ref7) {
  var _context2;
  var event = _ref7.event,
    removeStartIndex = _ref7.removeStartIndex,
    removeCharCount = _ref7.removeCharCount;
  var element = event.currentTarget;
  var _value = element.value;
  element.value = _concatInstanceProperty(_context2 = "".concat(_sliceInstanceProperty(_value).call(_value, 0, removeStartIndex))).call(_context2, _sliceInstanceProperty(_value).call(_value, removeStartIndex + removeCharCount));
  setSelectionRange({
    inputElement: element,
    selectionStart: removeStartIndex,
    selectionEnd: removeStartIndex
  });
};
var addValueOnKeyDown = function addValueOnKeyDown(params) {
  var _params$valueToBeAdde, _element$selectionSta2, _context3, _context4;
  var event = params.event;
  var element = event.currentTarget;
  var _value = element.value;
  var valueToBeAdded = (_params$valueToBeAdde = params.valueToBeAdded) !== null && _params$valueToBeAdde !== void 0 ? _params$valueToBeAdde : event.key;
  var addStartIndex = (_element$selectionSta2 = element.selectionStart) !== null && _element$selectionSta2 !== void 0 ? _element$selectionSta2 : 0;
  element.value = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "".concat(_sliceInstanceProperty(_value).call(_value, 0, addStartIndex))).call(_context4, valueToBeAdded)).call(_context3, _sliceInstanceProperty(_value).call(_value, addStartIndex));
  var nextSelection = params.keepCursorPosition ? addStartIndex : addStartIndex + valueToBeAdded.length;
  setSelectionRange({
    inputElement: element,
    selectionStart: nextSelection,
    selectionEnd: nextSelection
  });
};
var getOnBeforeKeyDownNumberInput = function getOnBeforeKeyDownNumberInput(_ref8) {
  var _ref8$formatType = _ref8.formatType,
    formatType = _ref8$formatType === void 0 ? INPUT_FORMAT_TYPE.COMMA_ADDED_NUMBER : _ref8$formatType,
    _ref8$unitOnValue = _ref8.unitOnValue,
    unitOnValue = _ref8$unitOnValue === void 0 ? '' : _ref8$unitOnValue,
    _ref8$maxDecimalDigit = _ref8.maxDecimalDigits,
    maxDecimalDigits = _ref8$maxDecimalDigit === void 0 ? 0 : _ref8$maxDecimalDigit;
  return function (e) {
    var _element$selectionSta3, _element$selectionEnd;
    var element = e.currentTarget;
    var selectionStart = (_element$selectionSta3 = element.selectionStart) !== null && _element$selectionSta3 !== void 0 ? _element$selectionSta3 : 0;
    var selectionEnd = (_element$selectionEnd = element.selectionEnd) !== null && _element$selectionEnd !== void 0 ? _element$selectionEnd : 0;
    var _value = element.value;
    if ((e.key === 'Backspace' || e.key === 'Delete') && selectionStart === selectionEnd) {
      var charToBeRemovedIndex = e.key === 'Backspace' ? selectionStart - 1 : selectionStart;
      /**
       * 1. Backspace로 반점 지울 때)
       * - 반점 앞의 숫자까지 지우기 위해, onKeyDown에서 반점 제거
       * - onChange e.target.value로 반점 앞의 숫자가 제거된 값이 전달됨
       *
       * 2. Delete로 반점 지울 때)
       * - 반점 뒤의 숫자까지 지우기 위해, onKeyDown에서 반점 제거
       * - onChange e.target.value로 반점 뒤의 숫자가 제거된 값이 전달됨
       */
      if (formatType === INPUT_FORMAT_TYPE.COMMA_ADDED_NUMBER && _value[charToBeRemovedIndex] === ',') {
        removeValueOnKeyDown({
          event: e,
          removeStartIndex: charToBeRemovedIndex,
          removeCharCount: 1
        });
      }
      /**
       * Backspace / Delete로 점 지울 때)
       * - 기존 값의 소수 부분이 정수 부분이 되면서, 기존 소수 부분에 반점이 추가될 수 있음
       * - 반점이 추가되면 reversedCursorPosition이 변경되어, onChange에서 커서 위치 정확하게 설정 불가
       * - reversedCursorPosition이 정확하게 계산되도록, onKeyDown에서 소수 부분에 반점을 추가 + 커서 위치는 기존과 동일하게 유지
       * - onChange e.target.value로 점이 제거된 값이 전달됨
       */
      if (_value[charToBeRemovedIndex] === '.') {
        var removeStartIndex = charToBeRemovedIndex + 1;
        var valueToBeRemoved = _sliceInstanceProperty(_value).call(_value, removeStartIndex).replace(unitOnValue, '');
        removeValueOnKeyDown({
          event: e,
          removeStartIndex: removeStartIndex,
          removeCharCount: valueToBeRemoved.length
        });
        addValueOnKeyDown({
          event: e,
          valueToBeAdded: getNumberString(valueToBeRemoved, {
            addComma: true,
            maxDecimalDigits: maxDecimalDigits
          }),
          keepCursorPosition: true
        });
      }
    }
    if (e.key === '.' && maxDecimalDigits) {
      var dotIndex = _indexOfInstanceProperty(_value).call(_value, '.');
      /**
       * 1. 점 없는 상태에서 점을 입력할 때)
       * - 점 뒤의 정수 부분이 소수 부분이 되면서, 점 뒤의 정수 부분에서 반점이 삭제됨 + 최대 소수점 자리수 maxDecimalDigits로 설정
       * - 이로 인해 reversedCursorPosition이 변경되면, onChange에서 커서 위치 정확하게 설정 불가
       * - reversedCursorPosition이 정확하게 계산되도록,
       *   onKeyDown에서 소수 부분의 반점을 삭제 + 최대 소수점 자리수 설정 + 커서 위치는 기존과 동일하게 유지
       * - onChange e.target.value로 점이 추가된 값이 전달됨
       *
       * 2. 소수점 앞쪽에 점을 입력할 때)
       * - 점 뒤의 정수 부분이 소수 부분이 되면서, 기존 소수점 & 소수 부분으로 변경될 정수 부분의 반점이 삭제됨 + 소수점 자리수 maxDecimalDigits로 설정됨
       * - 이로 인해 reversedCursorPosition이 변경되면, onChange에서 커서 위치 정확하게 설정 불가
       * - reversedCursorPosition이 정확하게 계산되도록,
       *   onKeyDown에서 기존 소수점 & 소수 부분으로 변경될 정수 부분의 반점을 삭제 + 최대 소수점 자리수 설정 + 커서 위치는 기존과 동일하게 유지
       * - onChange e.target.value로 점이 추가된 값이 전달됨
       *
       * 3. 소수점 뒤쪽에 점을 입력할 때)
       * - 기존 소수점을 유지해야 하기 때문에 onKeyDown에서 별도로 처리하지 않음
       */
      if (dotIndex === -1 || selectionStart < dotIndex) {
        var _context5;
        var _removeStartIndex = selectionStart;
        var decimalPart = _sliceInstanceProperty(_value).call(_value, _removeStartIndex).replace(unitOnValue, '');
        removeValueOnKeyDown({
          event: e,
          removeStartIndex: _removeStartIndex,
          removeCharCount: decimalPart.length
        });
        addValueOnKeyDown({
          event: e,
          valueToBeAdded: _sliceInstanceProperty(_context5 = getNumbersOnlyString(decimalPart)).call(_context5, 0, maxDecimalDigits),
          keepCursorPosition: true
        });
      }
    }
  };
};

export { addUnitOnValue, formatValueWithCorrectCursor, getMoveToNextStepInput, getMoveToPrevStepInput, getOnBeforeKeyDownNumberInput, getOnChange, getOnKeyDown };
